/**
 * 今日到店模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

Mock.mock(/insurance_quotes\/reviews/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'list|10': [{
      'user': { // 客户
        'name': '@word'
      },
      'offerer': { // 业务员
        'name': '@word'
      },
      'car': {
        'insurance_rating': '@word',
        'plate_number': '粤A@Integer(5,5)'
      },
      'quote_price': 10000,
      'quote_id|+1': 1,
      'created_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
      'edited_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
      'coupon_batches|2': [{
        'face_value': 10020,
        'title': '为个呢过过',
        'issue_count|1-100': 1
      }],
      'status': /pending_review|review_rejected|published/
    }],
    'count': 10,
    'page|+1': 1,
    'total_count': 40,
    'reviewer|1-2': false
  },
  'message': 'ok'
})
Mock.mock(/prepaid_orders\/reviews/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'list|10': [{
      'user': {
        'name': '@word'
      },
      'offerer': { // 业务员
        'name': '@word'
      },
      'car': {
        'insurance_rating': '@word',
        'plate_number': '粤A@Integer(5,5)'
      },
      'quote_price': 10000,
      'order_id|+1': 1,
      'created_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
      'coupon_batches|2': [{
        'face_value': 10020,
        'title': '二个人个人个',
        'issue_count|1-100': 1
      }],
      'status': /pending_review|review_rejected|published|pending_payment|paid|finished|closed/
    }],
    'count': 10,
    'page|+1': 1,
    'total_count': 30,
    'reviewer|1-2': false
  },
  'message': 'ok'
})
